// "Nhóm của nick" (người dùng duyệt 2026-10-04): nhóm Facebook của từng nick trên từng bot kèm trạng thái (đã vào / chưa vào / chờ duyệt /
// có câu hỏi). Lọc theo tên nhóm (gõ có dấu hay không dấu đều ra), theo bot / nick / trạng thái. Nút "Cập nhật danh sách nhóm" ra lệnh bot đọc lại
// trang "Nhóm của bạn" trên Facebook. Dữ liệu do bot gửi lên (server/src/nhom-nick.ts).
import { api, buildQuery, errMsg } from "../api";
import { busy, clear, gen, h, toast } from "../dom";
import { fmtTime } from "../format";
import { isSuper, loadBots, sortBots } from "../store";
import { MSG_DANG_DOC, NHAN_TRANG_THAI, TRANG_THAI_NHOM, type TrangThaiNhom } from "../../../../src/shared/nhom-nick";
import { conDangDocNhom, ghiDaRaLenhDocLai } from "../doc-lai-nhom";

type Dem = Record<TrangThaiNhom, number> & { tong: number };
interface NickRow { botId: string; botTen: string; nickId: string; nickTen: string; dem: Dem; capNhat: string }
interface NhomRow { botId: string; nickId: string; url: string; ten: string; trangThai: TrangThaiNhom; thanhVien: string | null; cheDo: string | null; nguon: string; tuKhoa: string | null; capNhat: string }
interface Xem { nick: NickRow[]; nhom: NhomRow[]; dem: Dem }

const MAU: Record<TrangThaiNhom, string> = { da_tham_gia: "ok", chua_tham_gia: "dry", cho_duyet: "warn", co_cau_hoi: "gold", khong_ro: "draft" };
const nguonChu = (n: NhomRow): string => (n.nguon === "tim_nhom" ? `tìm nhóm${n.tuKhoa ? ` “${n.tuKhoa}”` : ""}` : n.nguon === "tham_gia" ? "sau khi xin vào" : "trang Nhóm của bạn");

export async function renderNhomNick(root: HTMLElement, _p: Record<string, string>, query: URLSearchParams): Promise<() => void> {
  const alive = gen("nhom-nick");
  const botSel = h("select", { title: "Chỉ hiện nhóm của nick trên một bot", "data-testid": "nn-bot" }, h("option", { value: "" }, "Mọi bot"));
  const nickSel = h("select", { title: "Chỉ hiện nhóm của một nick", "data-testid": "nn-nick" }, h("option", { value: "" }, "Mọi nick"));
  const q = h("input", { type: "search", placeholder: "lọc theo tên nhóm, ví dụ: youtube", maxlength: 120, title: "Gõ có dấu hay không dấu đều được; nhiều từ = nhóm phải có đủ các từ", "data-testid": "nn-q" });
  const capNhat = h("button", { type: "button", class: "pri", title: "Ra lệnh bot đã chọn mở trang 'Nhóm của bạn' trên Facebook và đọc lại toàn bộ nhóm nick đã tham gia", "data-testid": "nn-cap-nhat" }, "Cập nhật danh sách nhóm");
  const tabs = h("div", { class: "row wrap", role: "tablist", "data-testid": "nn-tabs" });
  const info = h("p", { class: "muted small", "data-testid": "nn-info" }, "Đang tải…");
  const errBox = h("div", { class: "err-box", hidden: true, "data-testid": "page-error" });
  const empty = h("div", { class: "empty card", hidden: true, "data-testid": "nn-empty" });
  const tbody = h("tbody", { "data-testid": "nn-rows" });
  let trangThai = TRANG_THAI_NHOM.includes(query.get("trangThai") as TrangThaiNhom) ? (query.get("trangThai") as TrangThaiNhom) : "";
  q.value = query.get("q") ?? "";

  root.append(h("h1", {}, "Nhóm của nick"),
    h("p", { class: "small muted" }, "Nhóm Facebook của từng nick: đã vào, chưa vào, đang chờ duyệt hay nhóm có câu hỏi kiểm duyệt. Bot tự gửi lên mỗi khi tìm nhóm / xin vào nhóm; bấm ",
      h("b", {}, "Cập nhật danh sách nhóm"), " để bot đọc lại đủ các nhóm nick đã tham gia. Bước xin vào nhóm tự bỏ qua nhóm đã vào hoặc đang chờ duyệt."),
    h("div", { class: "card" },
      h("div", { class: "field-row" }, h("label", { class: "f" }, h("span", {}, "Bot"), botSel), h("label", { class: "f" }, h("span", {}, "Nick"), nickSel)),
      h("label", { class: "f" }, h("span", {}, "Tên nhóm có chữ"), q),
      h("div", { class: "row" }, capNhat)),
    tabs, info, errBox, empty,
    h("div", { class: "tbl" }, h("table", { "data-testid": "nn-table" },
      h("thead", {}, h("tr", {}, h("th", {}, "Tên nhóm"), h("th", {}, "Trạng thái"), h("th", {}, "Thành viên"), h("th", {}, "Nick"), h("th", { title: "Bot biết trạng thái này từ đâu" }, "Nguồn"), h("th", {}, "Cập nhật"))),
      tbody)));

  try {
    const bots = sortBots(await loadBots());
    if (!alive()) return () => {};
    for (const b of bots) botSel.append(h("option", { value: b.id }, isSuper() ? `${b.name} (${b.ownerName})` : b.name));
    botSel.value = query.get("botId") ?? "";
  } catch { /* không có danh sách bot thì vẫn xem được mọi nick */ }

  let lan = 0;
  let nickDs: NickRow[] = [];
  async function tai(): Promise<void> {
    const toi = ++lan;
    const [botId, nickId] = nickSel.value ? nickSel.value.split("\u0000") : [botSel.value, undefined];
    const qs = buildQuery({ botId: botId || undefined, nickId, q: q.value.trim() || undefined, trangThai: trangThai || undefined });
    errBox.hidden = true;
    let x: Xem;
    try { x = await api<Xem>("GET", `/api/nhom-nick${qs}`); } catch (e) {
      if (!alive() || toi !== lan) return;
      errBox.textContent = `Không tải được danh sách nhóm: ${errMsg(e)}`;
      errBox.hidden = false;
      info.textContent = "";
      return;
    }
    if (!alive() || toi !== lan) return; // lượt cũ trả về sau lượt mới (gõ nhanh) → bỏ
    nickDs = x.nick;
    veNick();
    veTabs(x.dem);
    clear(tbody);
    const tenNick = (n: NhomRow) => { const k = nickDs.find((y) => y.botId === n.botId && y.nickId === n.nickId); return k ? `${k.nickTen} · ${k.botTen}` : "?"; };
    for (const n of x.nhom.slice(0, 500)) {
      tbody.append(h("tr", { "data-testid": "nn-row", "data-tt": n.trangThai },
        h("td", {}, h("a", { href: n.url, target: "_blank", rel: "noopener noreferrer", "data-testid": "nn-ten" }, n.ten), n.cheDo ? h("div", { class: "muted small" }, n.cheDo) : null),
        h("td", {}, h("span", { class: `tag ${MAU[n.trangThai] ?? "draft"}`, "data-testid": "nn-tt" }, NHAN_TRANG_THAI[n.trangThai] ?? n.trangThai)),
        h("td", { class: "nowrap" }, n.thanhVien ?? ""),
        h("td", {}, tenNick(n)),
        h("td", { class: "small" }, nguonChu(n)),
        h("td", { class: "nowrap small" }, fmtTime(n.capNhat))));
    }
    const coLoc = !!(q.value.trim() || trangThai || botSel.value || nickSel.value);
    if (!x.nick.length) {
      empty.textContent = "Chưa có dữ liệu nhóm. Bot gửi danh sách nhóm khi chạy kịch bản tìm / tham gia nhóm Facebook — hoặc chọn một bot rồi bấm “Cập nhật danh sách nhóm”.";
      empty.hidden = false;
    } else if (!x.nhom.length) {
      empty.textContent = coLoc ? `Không có nhóm nào khớp bộ lọc${q.value.trim() ? ` “${q.value.trim()}”` : ""}.` : "Nick này chưa có nhóm nào.";
      empty.hidden = false;
    } else empty.hidden = true;
    const capNhatCuoi = x.nick.filter((n) => (!botSel.value || n.botId === botSel.value)).map((n) => n.capNhat).sort().at(-1);
    info.textContent = x.nick.length ? `${x.dem.tong} nhóm${x.nhom.length > 500 ? " (hiện 500 nhóm đầu — gõ thêm chữ để lọc)" : ""}${capNhatCuoi ? ` · cập nhật lần cuối ${fmtTime(capNhatCuoi)}` : ""}` : "";
  }
  function veNick(): void {
    const giu = nickSel.value;
    clear(nickSel);
    nickSel.append(h("option", { value: "" }, "Mọi nick"));
    for (const n of nickDs.filter((n) => !botSel.value || n.botId === botSel.value)) {
      nickSel.append(h("option", { value: `${n.botId}\u0000${n.nickId}` }, `${n.nickTen} — ${n.botTen} (${n.dem.tong} nhóm)`));
    }
    nickSel.value = [...nickSel.options].some((o) => o.value === giu) ? giu : "";
  }
  function veTabs(dem: Dem): void {
    clear(tabs);
    const nut = (tt: TrangThaiNhom | "", chu: string, n: number) => {
      const b = h("button", { type: "button", role: "tab", title: tt ? `Chỉ hiện nhóm “${chu}”` : "Hiện nhóm mọi trạng thái", "aria-selected": String(trangThai === tt), class: trangThai === tt ? "pri" : "", "data-testid": "nn-tab", "data-tt": tt || "tat_ca" }, `${chu} (${n})`);
      b.addEventListener("click", () => { trangThai = tt; void tai(); });
      return b;
    };
    tabs.append(nut("", "Tất cả", dem.tong), ...TRANG_THAI_NHOM.map((t) => nut(t, NHAN_TRANG_THAI[t], dem[t])));
  }

  let hen: ReturnType<typeof setTimeout> | undefined;
  q.addEventListener("input", () => { clearTimeout(hen); hen = setTimeout(() => void tai(), 250); });
  botSel.addEventListener("change", () => { nickSel.value = ""; void tai(); });
  nickSel.addEventListener("change", () => void tai());
  capNhat.addEventListener("click", () => {
    const botId = botSel.value || (nickSel.value ? nickSel.value.split("\u0000")[0] : "");
    if (!botId) { toast("Chọn một bot trước rồi bấm Cập nhật", "warn"); return; }
    if (conDangDocNhom(botId)) { toast(MSG_DANG_DOC, "warn"); return; } // đã ra lệnh vài phút trước: máy chủ chắc chắn trả 409 → không gửi (409 nào cũng thành dòng đỏ trong console)
    void busy(capNhat, "Đang ra lệnh…", async () => {
      try {
        await api("POST", "/api/nhom-nick/cap-nhat", { botId });
        ghiDaRaLenhDocLai(botId);
        toast("Đã ra lệnh — bot đang đọc trang 'Nhóm của bạn' (khoảng 1–2 phút), danh sách sẽ tự cập nhật", "info", 7000);
        for (const ms of [20_000, 45_000, 90_000, 150_000]) setTimeout(() => { if (alive()) void tai(); }, ms);
      } catch (e) { toast(errMsg(e), "err"); }
    });
  });
  await tai();
  return () => { clearTimeout(hen); };
}
